export const dotIcon = {
  data: `<svg viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.04809 6.00048C4.48934 6.00048 5.65771 4.83212 5.65771 3.39087C5.65771 1.94962 4.48934 0.78125 3.04809 0.78125C1.60684 0.78125 0.438477 1.94962 0.438477 3.39087C0.438477 4.83212 1.60684 6.00048 3.04809 6.00048Z" fill="currentColor"/></svg>`,
  name: 'dot' as const,
};
